import { isObject } from '../utils'
import { Compute } from '../Compute'

export default function (target, value, transformFn) {
  function set(context) {
    const { store, props, resolve } = context

    if (!resolve.isTag(target, 'state', 'props', 'moduleState')) {
      throw new Error(
        'Cerebral factory.set: You have to use the STATE, PROPS or MODULESTATE tag as first argument'
      )
    }

    let resolvedValue = resolve.value(value)

    if (resolvedValue && resolvedValue instanceof Compute) {
      resolvedValue = resolvedValue.getValue(props)
    }

    if (!resolve.isResolveValue(value) && isObject(value)) {
      resolvedValue = Object.assign({}, resolvedValue)
    } else if (!resolve.isResolveValue(value) && Array.isArray(value)) {
      resolvedValue = resolvedValue.slice()
    }

    if (transformFn) {
      resolvedValue = transformFn(resolvedValue, context)
    }

    if (target.type === 'state' || target.type === 'moduleState') {
      store.set(target, resolvedValue)
    } else {
      const result = Object.assign({}, props)
      const parts = resolve.path(target).split('.')
      const key = parts.pop()
      const targetObj = parts.reduce((target, key) => {
        return (target[key] = Object.assign({}, target[key] || {}))
      }, result)
      targetObj[key] = resolvedValue

      return result
    }
  }

  set.displayName = `factory.set(${String(target)}, ${String(value)})`

  return set
}
